import React from "react"
import Form from "react-bootstrap/Form"

export interface CheckBoxProps {
  id?: string
  label?: string
  checked?: boolean
  disabled?: boolean
  indeterminate?: boolean
  onToggle: (e: any) => void
}

const CheckBox = (props: CheckBoxProps) => {
  const toggle = (e: any) => {
    if (!props.disabled) {
      props.onToggle(e)
    }
  }

  const dummy = () => {} // To silence react warning of controlled checkboxes.

  return (
    <Form.Group controlId={props.id} className="mb-0">
      <div className="custom-control custom-checkbox">
        <Form.Control
          type="checkbox"
          checked={props.checked}
          className="custom-control-input"
          onChange={dummy}
          disabled={props.disabled}
          ref={(e: any) => e && (e.indeterminate = props.indeterminate)}
        />
        <Form.Label className="custom-control-label w-100" onClick={toggle}>
          {props.label || ""}
        </Form.Label>
      </div>
    </Form.Group>
  )
}

export default CheckBox
